import { render } from "./Email.vue?vue&type=template&id=915aff6c&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"

import "./Email.vue?vue&type=style&index=0&id=915aff6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jonathant\\ucaas-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915aff6c"]])

export default __exports__